/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReceiptsRouteImport } from './routes/receipts'
import { Route as LoyaltyRouteImport } from './routes/loyalty'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as CartRouteImport } from './routes/cart'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReceiptReceiptIdRouteImport } from './routes/receipt/$receiptId'
import { Route as ProductProductIdRouteImport } from './routes/product/$productId'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'
import { Route as OnboardingLoginRouteImport } from './routes/onboarding/login'
import { Route as OnboardingIntroRouteImport } from './routes/onboarding/intro'

const ReceiptsRoute = ReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => rootRouteImport,
} as any)
const LoyaltyRoute = LoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteAccountRoute = DeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReceiptReceiptIdRoute = ReceiptReceiptIdRouteImport.update({
  id: '/receipt/$receiptId',
  path: '/receipt/$receiptId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductProductIdRoute = ProductProductIdRouteImport.update({
  id: '/product/$productId',
  path: '/product/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/onboarding/welcome',
  path: '/onboarding/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingLoginRoute = OnboardingLoginRouteImport.update({
  id: '/onboarding/login',
  path: '/onboarding/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIntroRoute = OnboardingIntroRouteImport.update({
  id: '/onboarding/intro',
  path: '/onboarding/intro',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/delete-account': typeof DeleteAccountRoute
  '/loyalty': typeof LoyaltyRoute
  '/receipts': typeof ReceiptsRoute
  '/onboarding/intro': typeof OnboardingIntroRoute
  '/onboarding/login': typeof OnboardingLoginRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/product/$productId': typeof ProductProductIdRoute
  '/receipt/$receiptId': typeof ReceiptReceiptIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/delete-account': typeof DeleteAccountRoute
  '/loyalty': typeof LoyaltyRoute
  '/receipts': typeof ReceiptsRoute
  '/onboarding/intro': typeof OnboardingIntroRoute
  '/onboarding/login': typeof OnboardingLoginRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/product/$productId': typeof ProductProductIdRoute
  '/receipt/$receiptId': typeof ReceiptReceiptIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/delete-account': typeof DeleteAccountRoute
  '/loyalty': typeof LoyaltyRoute
  '/receipts': typeof ReceiptsRoute
  '/onboarding/intro': typeof OnboardingIntroRoute
  '/onboarding/login': typeof OnboardingLoginRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/product/$productId': typeof ProductProductIdRoute
  '/receipt/$receiptId': typeof ReceiptReceiptIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cart'
    | '/delete-account'
    | '/loyalty'
    | '/receipts'
    | '/onboarding/intro'
    | '/onboarding/login'
    | '/onboarding/welcome'
    | '/product/$productId'
    | '/receipt/$receiptId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cart'
    | '/delete-account'
    | '/loyalty'
    | '/receipts'
    | '/onboarding/intro'
    | '/onboarding/login'
    | '/onboarding/welcome'
    | '/product/$productId'
    | '/receipt/$receiptId'
  id:
    | '__root__'
    | '/'
    | '/cart'
    | '/delete-account'
    | '/loyalty'
    | '/receipts'
    | '/onboarding/intro'
    | '/onboarding/login'
    | '/onboarding/welcome'
    | '/product/$productId'
    | '/receipt/$receiptId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CartRoute: typeof CartRoute
  DeleteAccountRoute: typeof DeleteAccountRoute
  LoyaltyRoute: typeof LoyaltyRoute
  ReceiptsRoute: typeof ReceiptsRoute
  OnboardingIntroRoute: typeof OnboardingIntroRoute
  OnboardingLoginRoute: typeof OnboardingLoginRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  ProductProductIdRoute: typeof ProductProductIdRoute
  ReceiptReceiptIdRoute: typeof ReceiptReceiptIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/receipts': {
      id: '/receipts'
      path: '/receipts'
      fullPath: '/receipts'
      preLoaderRoute: typeof ReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loyalty': {
      id: '/loyalty'
      path: '/loyalty'
      fullPath: '/loyalty'
      preLoaderRoute: typeof LoyaltyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account': {
      id: '/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof DeleteAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/receipt/$receiptId': {
      id: '/receipt/$receiptId'
      path: '/receipt/$receiptId'
      fullPath: '/receipt/$receiptId'
      preLoaderRoute: typeof ReceiptReceiptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/$productId': {
      id: '/product/$productId'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof ProductProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/onboarding/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/login': {
      id: '/onboarding/login'
      path: '/onboarding/login'
      fullPath: '/onboarding/login'
      preLoaderRoute: typeof OnboardingLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/intro': {
      id: '/onboarding/intro'
      path: '/onboarding/intro'
      fullPath: '/onboarding/intro'
      preLoaderRoute: typeof OnboardingIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CartRoute: CartRoute,
  DeleteAccountRoute: DeleteAccountRoute,
  LoyaltyRoute: LoyaltyRoute,
  ReceiptsRoute: ReceiptsRoute,
  OnboardingIntroRoute: OnboardingIntroRoute,
  OnboardingLoginRoute: OnboardingLoginRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  ProductProductIdRoute: ProductProductIdRoute,
  ReceiptReceiptIdRoute: ReceiptReceiptIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
